import { Box, Text } from '@usealloy/component-library';
import styled from 'styled-components';
// import this instead of redefining it to ensure consistency if we change BaseNode width
import { NODE_TEXT_MAX_WIDTH } from '../BaseNode/BaseNode.styles';

export const StyledRiskScoringIconContainer = styled(Box)`
  background: var(--cl-juicyBlue-400);
  border-radius: var(--cl-radius-3);
  padding: var(--cl-space-1);
  width: fit-content;
  // BaseNode has a 4px gap between the icon and the text
  // We want an 8px gap, so we add 4px as a margin
  margin-right: var(--cl-space-1);
`;

export const StyledLabelText = styled(Text)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  // Shorten the max text width to account for the larger icon and gap
  max-width: calc(${NODE_TEXT_MAX_WIDTH}px - 24px);
`;
